import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { API_URL } from "./config";
import { ERROR } from "@/router/constant";
import router from "@/router/index";
import hsa from "@/configs/hsa.json";
import lpa from "@/configs/lpa.json";
import hsaDev from "@/configs/hsa-dev.json";
import lpaDev from "@/configs/lpa-dev.json";
import {
  APP_STORAGE_WEB_KEY,
  APP_STORAGE_LANGUAGE_KEY,
} from "@/router/constant";

const setupBaseUrl = () => {
  const storeData = JSON.parse(localStorage.getItem("vendor_app"));
  switch (storeData.system) {
    case "hsa":
      if (process.env.NODE_ENV === "production") {
        Vue.axios.defaults.baseURL = hsa.apiUrl;
        document.title = hsa.appName;
      } else {
        Vue.axios.defaults.baseURL = hsaDev.apiUrl;
        document.title = hsaDev.appName;
      }
      break;
    case "lpa":
      if (process.env.NODE_ENV === "production") {
        Vue.axios.defaults.baseURL = lpa.apiUrl;
        document.title = lpa.appName;
      } else {
        Vue.axios.defaults.baseURL = lpaDev.apiUrl;
        document.title = hsaDev.appName;
      }
      break;
    default:
      Vue.axios.defaults.baseURL = hsaDev.apiUrl;
      document.title = hsaDev.appName;
      break;
  }

  // const storeData = JSON.parse(localStorage.getItem('vendor-app'));
  // console.log('storeData', storeData);
  // switch (storeData.system) {
  //   case 'hsa':
  //     Vue.axios.defaults.baseURL = hsa.apiUrl;
  //     document.title = hsa.appName;
  //     break;
  //   case 'hsa-dev':
  //     Vue.axios.defaults.baseURL = hsaDev.apiUrl;
  //     document.title = hsaDev.appName;
  //     break;
  //   case 'lpa':
  //     Vue.axios.defaults.baseURL = lpa.apiUrl;
  //     document.title = lpa.appName;
  //     break;
  //   case 'lpa-dev':
  //     Vue.axios.defaults.baseURL = lpaDev.apiUrl;
  //     document.title = lpaDev.appName;
  //     break;
  //   default:
  //     Vue.axios.defaults.baseURL = hsaDev.apiUrl;
  //     document.title = hsaDev.appName;
  //     break;
  // }
};

const setupBaseCustomerUrl = () => {
  // if (process.env.NODE_ENV === "production") {
  // Vue.axios.defaults.baseURL = API_URL;
  // } else {
  //   Vue.axios.defaults.baseURL = API_URL;
  // }
  if (process.env.NODE_ENV === "production") {
    Vue.axios.defaults.baseURL = hsa.apiUrl;
    document.title = hsa.appName;
  } else {
    Vue.axios.defaults.baseURL = hsaDev.apiUrl;
    document.title = hsaDev.appName;
  }
};

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },
  get(token, resource, params, headers) {
    setupBaseUrl();
    const storeData = JSON.parse(localStorage.getItem("vendor_app"));
    return new Promise((resolve, reject) => {
      const payload = { headers: { Authorization: token, ...headers }, params };
      Vue.axios
        .get(resource, payload)
        .then((resp) => resolve(resp.data))
        .catch((error) => {
          reject(error);
          router.push({
            name: ERROR,
            params: {
              env: storeData.system,
              code: error.response.data.code,
            },
          });
        });
    });
  },
  post(token, resource, payload, headers) {
    setupBaseUrl();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(resource, payload, {
          headers: { Authorization: token, ...headers },
        })
        .then((resp) => resolve(resp.data))
        .catch((error) => reject(error));
    });
  },
  put(token, resource, payload) {
    setupBaseUrl();
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(resource, payload, { headers: { Authorization: token } })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  patch(token, resource, payload) {
    setupBaseUrl();
    return new Promise((resolve, reject) => {
      Vue.axios
        .patch(resource, payload, { headers: { Authorization: token } })
        .then((resp) => resolve(resp.data))
        .catch((error) => reject(error));
    });
  },
  delete(token, resource) {
    setupBaseUrl();
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(resource, { headers: { Authorization: token } })
        .then((resp) => resolve(resp.data))
        .catch((error) => reject(error));
    });
  },
};

const ApiCustomerService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },
  get(token, resource, params, headers) {
    setupBaseCustomerUrl();
    return new Promise((resolve, reject) => {
      const payload = { headers: { Authorization: token, ...headers }, params };
      Vue.axios
        .get(resource, payload)
        .then((resp) => resolve(resp.data))
        .catch((error) => {
          reject(error);
          router.push({
            name: ERROR,
            params: {
              code: error?.response?.data?.code,
            },
          });
        });
    });
  },
};

export default ApiService;

export const BookingService = {
  listBooking(token) {
    console.log("listBooking");
    return ApiService.get(
      token,
      `commercial-service/landing-page/bookings`,
      {},
      { "Accept-Language": "th" },
    );
  },
  getBooking(token, bookingId) {
    return ApiService.get(
      token,
      `commercial-service/landing-page/bookings/${bookingId}`,
      {},
      { "Accept-Language": "th" },
    );
  },
  cancelBooking(token, bookingId, payload) {
    return ApiService.post(
      token,
      `commercial-service/landing-page/bookings/${bookingId}/cancel`,
      payload,
      { "Accept-Language": "th" },
    );
  },
  updateStatus(token, bookingId, payload) {
    return ApiService.post(
      token,
      `commercial-service/landing-page/bookings/${bookingId}/status`,
      payload,
      { "Accept-Language": "th" },
    );
  },
  changeAppointment(token, bookingId, payload) {
    return ApiService.patch(
      token,
      `commercial-service/landing-page/bookings/${bookingId}/appointment`,
      payload,
      { "Accept-Language": "th" },
    );
  },
  getSettingsCancelReasons(token) {
    return ApiService.get(
      token,
      `commercial-service/landing-page/settings/cancel-reasons`,
      {},
      { "Accept-Language": "th" },
    );
  },
};

export const ShopService = {
  getBookingPaymentTransaction() {
    // console.log("getBookingPaymentTransaction bookingNo:", bookingNo);
    const storeData = JSON.parse(localStorage.getItem(APP_STORAGE_WEB_KEY));
    console.log("storeData", storeData);
    const { accessToken, bookingNo } = storeData;
    const langCode = JSON.parse(
      localStorage.getItem(APP_STORAGE_LANGUAGE_KEY),
    )?.langCode;

    console.log("langCode", langCode);
    return ApiCustomerService.get(
      accessToken,
      `customers/commercial-service/landing-page/bookings/${bookingNo}/payment-transactions`,
      null,
      {
        "Accept-Language": langCode ?? "en",
      },
    );
  },
};
